<template>
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <h3>基本信息</h3>
    <div class="detail">
      <div
        class="img"
        v-if="!body.avatar">暂无头像</div>
      <img
        v-else
        class="img"
        :src="body.avatar"
        alt="">
      <el-form
        :inline="false"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item
          class="dk-input"
          label="用户昵称:">
          <span>{{ body.nickname }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="积分ID">
          <span>{{ body.invite_code }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="手机号">
          <span>{{ body.mobile }}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="积分余额">
          <span>{{ body.point }}</span>
          <el-button
            type="primary"
            size="mini"
            @click="dialogFormVisible = true">修改积分</el-button>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="注册时间">
          <span>{{ body.create_time }}</span>
        </el-form-item>
        <el-form-item
          label="积分明细">
          <el-button
            type="primary"
            @click="event().onPointDetailClick()">查看明细</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog title="修改积分" :visible.sync="dialogFormVisible" width="25%">
      <el-form>
        <el-form-item label="*积分余额" :label-width="formLabelWidth">
          <el-input v-model="pointBody.point" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="*注释" :label-width="formLabelWidth">
          <el-input v-model="pointBody.desc" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="event().onChangePointClick()">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { imgDomain } from '../../configs/env'
import { getUserDetail, changePoint } from '../../api/user'

export default {
  data() {
    return {
      imgDomain,
      body: {
      },
      pointBody: {},
      dialogFormVisible: false,
      formLabelWidth: '120px'
    };
  },
  created() {
    this.network().getUserDetail()
  },
  methods: {
    event() {
      return {
        onBackClick: () => {
          this.$router.go(-1)
        },
        onPointDetailClick: () => {
          this.$router.push({ path: 'point-detail', query: { uuid: this.$route.query.uuid } })
        },
        onChangePointClick: () => {
          this.network().changePoint()
        },
      }
    },
    network() {
      return {
        getUserDetail: async () => {
          const { status, data } = await getUserDetail(this.$route.query.uuid)
          if (status !== 200) return
          this.body = data
          this.pointBody.point = data.point
        },
        changePoint: async () => {
          let data = {...this.pointBody}
          data.uuid = this.$route.query.uuid
          const { status } = await changePoint(data)
          if (status !== 200) return
          this.network().getUserDetail()
          this.$notify({
            title: '修改积分成功',
            message: '修改用户积分成功',
            type: 'success',
          });
          this.$set(this.body, 'point', this.pointBody)
          this.dialogFormVisible = false
        },
      }
    },
    handler() {
      return {

      }
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
.detail{
  display: flex;
}
.img{
  min-width: 148px;
  height: 148px;
  border-radius: 6px;
  border: 1px solid #c0ccda;
  margin: 0 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/user/detail.vue